import React from "react";
import { Heart } from "lucide-react";
import { Reveal } from "@/components/Ornaments";

const Calendar = ({ data }) => {
  const c = data.calendar;
  const cells = [];
  for (let i = 0; i < c.leadingBlanks; i++) cells.push(null);
  for (let d = 1; d <= c.daysInMonth; d++) cells.push(d);

  return (
    <Reveal>
      <section data-testid="wedding-calendar" className="text-center">
        <p className="eyebrow mb-2">ჩვენი ქორწილის დღე</p>
        <h2 className="font-display text-lg uppercase tracking-[0.3em] text-[#292524]">
          {c.monthLabel} <span className="gold-text">{c.year}</span>
        </h2>
        <div className="gold-frame mx-auto mt-6 max-w-[310px] bg-white px-4 py-5">
          <div className="mb-2 grid grid-cols-7">
            {c.weekdays.map((w) => (
              <span key={w} className="py-1 text-[9px] font-semibold uppercase tracking-wider text-[#A1A1AA]">{w}</span>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-y-1">
            {cells.map((d, i) => {
              if (d === null) return <span key={`b${i}`} />;
              if (d === c.weddingDay) {
                return (
                  <div key={d} data-testid="calendar-wedding-day" className="relative mx-auto flex h-9 w-9 -rotate-[10deg] items-center justify-center">
                    <Heart className="absolute h-8 w-8 text-[#DC2626] drop-shadow-[0_3px_6px_rgba(220,38,38,0.45)]" fill="currentColor" aria-hidden="true" />
                    <span className="relative pb-0.5 text-[11px] font-bold text-white">{d}</span>
                  </div>
                );
              }
              return (
                <div key={d} className="mx-auto flex h-9 w-9 items-center justify-center text-sm text-[#57534E]">{d}</div>
              );
            })}
          </div>
        </div>
        <p className="font-editorial mt-4 text-base italic text-[#78716C]">{c.footer}</p>
      </section>
    </Reveal>
  );
};

export default Calendar;
